import { render, staticRenderFns } from "./EditRegionMeter.vue?vue&type=template&id=2234c9bc"
import script from "./EditRegionMeter.vue?vue&type=script&lang=js"
export * from "./EditRegionMeter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports